import React, { Fragment } from 'react'
import { withRouter } from "react-router-dom";
import {
    isCreatorOrAdministrator,
    isCreatorOrAdministratorOrInternalContributor,
    userHasRoles
} from "../../utils/UserInfo";
import { Button, Table } from "antd";
import Spinner from "../Spinner";
import Text from "antd/lib/typography/Text";
import CommentsIcon from "../CommentsIcon";
import { tabNamesMap } from "../TabNamesMap";
import UndoPopUp from "../UndoPopUp";
import moment from "moment";
import FileExport from "../FileExport";
import ReactTooltip from "react-tooltip";

export default withRouter(function ProjectsList(props) {

    const { projects, allTab, location, tabView } = props;
    const { onButtonClick } = props;

    function getActionsForStatus(project) {
        let actions = [];
        if (project.projectStatus === 'U') {
            actions.push(isCreatorOrAdministrator() ? <Button id={'listEditLink' + project.id} type={"link"} style={{ height: 'auto' }} onClick={() => onButtonClick(project)}>Start Project</Button> : <Text>Contact CCA</Text>)
        } else if (project.projectStatus === 'N') {
            actions.push(!isCreatorOrAdministrator() ? <Text>Contact CCA</Text> : <UndoPopUp
                project={project}
                undoStatus={"Re-Activate"} />)
        } else {
            actions.push(userHasRoles() ? <Button id={'listEditLink' + project.id} type={"link"} style={{ height: 'auto' }} onClick={() => onButtonClick(project)}>Go To Project</Button> : <Text>Contact CCA</Text>)
        }
        return actions;
    }


    const renderEllipsisForProjectData = (dataVals, type) => {
        const convertedArray = dataVals && dataVals.split(",");
        if (convertedArray !== null && convertedArray.length && convertedArray.length >= 4) {
            return (
                <>
                    <div style={{ alignItems: 'left', width: 120 }} data-tip data-for={'toolTip-' + type}>
                        {convertedArray.slice(0, 3).map(item => (
                            item)).join(', ')}{' ...'}
                    </div>
                    <ReactTooltip id={'toolTip-' + type} place="bottom" effect="solid" textColor='black' backgroundColor='white' border={true} borderColor="black" type="info">
                        {convertedArray.map(item => (
                            item
                        )).join(', ')}
                    </ReactTooltip>
                </>
            )
        }
        else {
            return <div style={{ alignItems: 'left' }}>{dataVals}</div>
        }
    }

    const renderEllipsisForProjectDescData = (data, projectData, type) => {
        const convertedArray = data && data.split("|");
        if (convertedArray !== null && convertedArray.length && convertedArray.length >= 4) {
            return (
                <>
                    {convertedArray.slice(0, 3).map((item, index) =>
                        <div style={{ alignItems: 'left', width: 270 }} data-tip data-for={'toolTip-' + type}>{index + 1}) {item}{index === 2 && ' ...'}</div>
                    )}
                    <ReactTooltip id={'toolTip-' + type} place="bottom" effect="solid" textColor='black' backgroundColor='white' border={true} borderColor="black" type="info">
                        {convertedArray.map((item, index) => (
                            <div>{index + 1}) {item}</div>
                        ))}
                    </ReactTooltip>
                </>
            )
        }
        else if (convertedArray !== null && convertedArray.length && convertedArray.length > 1) {
            return (
                convertedArray.slice().map((item, index) =>
                    <div style={{ alignItems: 'left', width: 270 }}>{index + 1}) {item}</div>
                )
            )
        }
        else {
            return (
                <div style={{ alignItems: 'left', width: 270 }}>
                    {data || projectData.projectDescription}
                </div>
            )
        }
    }

    // const renderStationName = (data) => {
    //     return (
    //         <>
    //             <div style={{ alignItems: 'left'}}>
    //                 {data}
    //             </div>
    //         </>
    //     )
    // }

    const renderStationName = (stationName, project) => {

        return {

            children: (
                <>
                    {project.projectStatus === 'N' ? !isCreatorOrAdministrator() ? <div>{stationName}</div>
                        : <UndoPopUp
                            project={project}
                            undoStatus={stationName}
                        />
                        : project.projectStatus === 'U' ? isCreatorOrAdministrator() ?
                            <Button
                                id={'inDevCardEditLink'}
                                type={'link'}
                                onClick={() => onButtonClick(project)}
                                style={{
                                    height: 'auto',
                                    paddingLeft: '0px',
                                    paddingRight: '0px',
                                    alignItems: 'left',
                                    marignLeft: '0px',
                                }}
                            >
                                <span
                                    className="station-name"
                                >
                                    {stationName || ''}
                                </span>
                            </Button>
                            : <div>{stationName}</div>
                            : <Button
                                id={'inDevCardEditLink'}
                                type={'link'}
                                onClick={() => onButtonClick(project)}
                                style={{
                                    height: 'auto',
                                    paddingLeft: '0px',
                                    paddingRight: '0px',
                                    alignItems: 'left',
                                    marignLeft: '0px',
                                }}
                            >
                                <span
                                    className="station-name"
                                >
                                    {stationName || ''}
                                </span>
                            </Button>}
                </>
            ),
        };

    };

    const columns = [
        {
            title: "Station Name",
            dataIndex: 'stationName',
            key: 'stationName',
            fixed: 'left',
            sorter: (a, b) => {
                a = a.stationName || '';
                b = b.stationName || '';
                return b.localeCompare(a)
            },
            render: (stationName, project) => renderStationName(stationName, project),
        },
        {
            title: "Status",
            dataIndex: 'projectStatus',
            key: 'projectStatus',
            fixed: 'left',
            render: (text, project) => {
                return ((allTab && allTab === "Y") && project.projectStatus !== null ? tabNamesMap[project.projectStatus] : " ")
            },
            sorter: (a, b) => {
                a = a.projectStatus || '';
                b = b.projectStatus || '';
                return b.localeCompare(a)
            },
        },
        {
            title: "Project Description",
            dataIndex: 'allProjectDescs',
            key: 'projectDescription',
            fixed: 'left',
            render: (allProjectDescs, projectData) => renderEllipsisForProjectDescData(allProjectDescs, projectData, 'projectDescription'),
            sorter: (a, b) => {
                a = a.projectDescription || '';
                b = b.projectDescription || '';
                return b.localeCompare(a)
            }
        },
        {
            title: "Construction Start Date",
            dataIndex: 'constructionStartDate',
            key: 'constructionStartDate',
            sorter: (a, b) => {
                a = a.constructionStartDate || moment("1900-01-01");
                b = b.constructionStartDate || moment("1900-01-01");
                if (moment(a).isValid() && moment(b).isValid())
                    return moment(a).unix() - moment(b).unix()
                else if (moment(a).isValid())
                    return moment(a).unix()
                else if (moment(b).isValid())
                    return moment(b).unix()
                else
                    return moment(a).unix() - moment(b).unix();
            },
        },
        {
            title: "Checklist Release Date",
            dataIndex: 'commisioningStartDate',
            key: 'commisioningStartDate',
            sorter: (a, b) => {
                a = a.commisioningStartDate || moment("1900-01-01");
                b = b.commisioningStartDate || moment("1900-01-01");
                if (moment(a).isValid() && moment(b).isValid())
                    return moment(a).unix() - moment(b).unix()
                else if (moment(a).isValid())
                    return moment(a).unix()
                else if (moment(b).isValid())
                    return moment(b).unix()
                else
                    return moment(a).unix() - moment(b).unix();
            },
        },
        {
            title: "Expected Close Date",
            //we are still keeping logic for this because if we chose expectedCloseDate or defExpecatedClose in render we are received data  null
            dataIndex: "expectedCloseDate" ? 'defExpectedCloseDate' : 'expectedCloseDate',
            key: 'expectedCloseDate',
            sorter: (a, b) => {
                a = (a.defExpectedCloseDate ? a.defExpectedCloseDate : a.expectedCloseDate) || moment("1900-01-01");
                b = (b.defExpectedCloseDate ? b.defExpectedCloseDate : b.expectedCloseDate) || moment("1900-01-01");
                if (moment(a).isValid() && moment(b).isValid())
                    return moment(a).unix() - moment(b).unix()
                else if (moment(a).isValid())
                    return moment(a).unix()
                else if (moment(b).isValid())
                    return moment(b).unix()
                else
                    return moment(a).unix() - moment(b).unix();
            },
            //             render: ( project,projectData) => {
            // console.log(project)
            //                 // return projectData.defExpectedCloseDate ? projectData.defExpectedCloseDate:projectData.expectedCloseDate
            //             },
        },
        {
            title: "In-Service Date",
            dataIndex: 'inServiceDate',
            key: 'inServiceDate',
            sorter: (a, b) => {
                a = a.inServiceDate || moment("1900-01-01");
                b = b.inServiceDate || moment("1900-01-01");
                if (moment(a).isValid() && moment(b).isValid())
                    return moment(a).unix() - moment(b).unix()
                else if (moment(a).isValid())
                    return moment(a).unix()
                else if (moment(b).isValid())
                    return moment(b).unix()
                else
                    return moment(a).unix() - moment(b).unix();
            },
        },
        {
            title: "WO",
            dataIndex: 'workOrder',
            key: 'workOrder',
            render: (workOrderVals) => renderEllipsisForProjectData(workOrderVals, 'workOrder'),
            sorter: (a, b) => {
                a = a.workOrder || '';
                b = b.workOrder || '';
                return b.localeCompare(a)
            },
        },
        {
            title: "BPID",
            dataIndex: 'bpid',
            key: 'bpid',
            render: (bpidVals) => renderEllipsisForProjectData(bpidVals, 'bpid'),
            sorter: (a, b) => {
                a = a.bpid || '';
                b = b.bpid || '';
                return b.localeCompare(a)
            },
        },
        {
            title: "MPID",
            dataIndex: 'mpid',
            key: 'mpid',
            render: (mpidVals) => renderEllipsisForProjectData(mpidVals, 'mpid'),
            sorter: (a, b) => {
                a = a.mpid || '';
                b = b.mpid || '';
                return b.localeCompare(a)
            },
        },
        {
            title: "Station Region",
            dataIndex: 'stationRegion',
            key: 'stationRegion',
            sorter: (a, b) => {
                a = a.stationRegion || '';
                b = b.stationRegion || '';
                return b.localeCompare(a)
            },
        },
        {
            title: "TFS Station Area",
            dataIndex: 'tfStationArea',
            key: 'tfStationArea',
            sorter: (a, b) => {
                a = a.tfStationArea || '';
                b = b.tfStationArea || '';
                return b.localeCompare(a)
            },
        },
        {
            title: "TFS PC Area",
            dataIndex: 'pcArea',
            key: 'pcArea',
            sorter: (a, b) => {
                a = a.pcArea || '';
                b = b.pcArea || '';
                return b.localeCompare(a)
            },
        },
        {
            title: "No.of Assets",
            dataIndex: "noOfAssets",
            key: 'noOfAssets',
            sorter: (a, b) => {
                a = a.noOfAssets || '';
                b = b.noOfAssets || '';
                return b - a;

            },
        },
        {
            title: "No. of Assets Assigned a Section",
            dataIndex: "noOfSectionAssets",
            key: 'noOfSectionAssets',
            sorter: (a, b) => {
                a = a.noOfSectionAssets || '';
                b = b.noOfSectionAssets || '';
                return b - a;

            },
        },
        {
            title: "No. of Assets Assigned a Pre-E Form",
            dataIndex: "noOfFormAssets",
            key: 'noOfFormAssets',
            sorter: (a, b) => {
                a = a.noOfFormAssets || '';
                b = b.noOfFormAssets || '';
                return b - a;

            },
        },
       /* {
            title: "Actions",
            dataIndex: 'startProject',
            key: 'startProject',
            render: (text, project) => {
                return (getActionsForStatus(project))
            }
        },*/
        {
            title: "Comments",
            dataIndex: 'comment',
            key: '',
            render: (text, project) => <CommentsIcon project={project} />,
        }
    ];

    return (
        <Fragment>
            <div className="table-responsive">
                <Spinner />
                <Table
                    id={'projectListTable'}
                    className={"table-striped"}
                    columns={columns.filter(column => (allTab && allTab === "Y") ? true : column.dataIndex != 'projectStatus')}
                    dataSource={projects}
                    pagination={{ showSizeChanger: false, pageSize: 10 }}
                    scroll={{ x: 'max-content' }}

                />
            </div>
        </Fragment>
    )
})
